import { message } from 'antd'
import { useMutation, useQuery } from 'react-query'

import {
  createOrUpdateApproval,
  executeMassApproval,
  executeMassApprovalReject,
  getApprovable,
  getApprovalSettings,
  inputMassApproval,
  inputMassApprovalReject,
} from 'utils/apis'
import { getMyApprovableTotal } from '../apis'

export const useCreateOrUpdateApproval = () => {
  return useMutation((payload) => createOrUpdateApproval(payload))
}

export const useApprovalSettings = ({ payload = {}, options = {} } = {}) => {
  return useQuery(
    ['approvals', payload],
    async () => {
      const {
        data: { data },
      } = await getApprovalSettings(payload)
      return data
    },
    {
      onError: (error) =>
        message.error((error && error.message) || 'Failed to load data from server!'),
      ...options,
    },
  )
}

export const useApprovable = ({ payload = {}, options = {} } = {}) => {
  return useQuery(
    ['approveable', payload],
    async () => {
      const {
        data: { data },
      } = await getApprovable(payload)
      return data
    },
    {
      onError: (error) =>
        message.error((error && error.message) || 'Failed to load data from server!'),
      ...options,
    },
  )
}

export const useInputMassApproval = () => {
  return useMutation((payload) => inputMassApproval(payload))
}

export const useExecuteMassApproval = () => {
  return useMutation(executeMassApproval)
}

export const useInputMassApprovalReject = () => {
  return useMutation((payload) => inputMassApprovalReject(payload))
}

export const useExecuteMassApprovalReject = () => {
  return useMutation(executeMassApprovalReject)
}

export const useMyApprovableTotal = (options = {}) => {
  return useQuery(
    ['myApprovableTotal'],
    async () => {
      const { data } = await getMyApprovableTotal()
      return data
    },
    { ...options },
  )
}
